import {AnyObject, Application} from 'src';

/**
 * app挂载
 * @param app
 * @param options
 * @returns
 */
export default function mountApp(
  app: Application,
  options: AnyObject,
): Promise<any> {
  const result = (app as Application).mount(options);
  return Promise.resolve(result)
    .then(() => {})
    .catch((err: Error) => {
      throw err;
    });
}
